import React, { useState, useEffect } from "react";
import { defineBlock } from "@smartfire/gutenberg-react";
import style from "./block.module.scss";
import { ReactComponent as LogoSpi } from "../assets/logo_spi.svg";
import { ReactComponent as Menu } from "./menu.svg";
import { ReactComponent as Close } from "./close.svg";
import { ReactComponent as Facebook } from "../assets/facebook.svg";
import { ReactComponent as LinkedIn } from "../assets/linkedin.svg";
import { ReactComponent as Youtube } from "../assets/youtube.svg";

function Block({ custom_settings, menuHeader, menuLang, isHomeHeroPage }) {
  const [isOpen, setOpen] = useState(false);
  const [isBlue, setBlue] = useState(true);
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflowY = "hidden";
      setBlue(false);
      return () => {
        document.body.style.overflowY = null;
      };
    } else {
      //To avoid text to become white before the end of the css height transition
      const timer = setTimeout(() => {
        setBlue(true);
      }, 200);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);
  return (
    <div className={isHomeHeroPage ? style.homeHero : style.generic}>
      <div className={isBlue ? style.headerBlue : style.header}>
        <a className={style.logo} href="/">
          <LogoSpi />
          <div className={style.bar} />
          <div className={style.text}>VALUES SUPPLY CHAIN</div>
        </a>
        <div className={style.right}>
          {
            <div
              className={style.menuLang}
              dangerouslySetInnerHTML={{ __html: menuLang }}
            />
          }
          <div className={style.menuLogo}>
            <div className={style.click} onClick={() => setOpen(!isOpen)}>
              <div className={style.text}>{isOpen ? "FERMER" : "MENU"}</div>
              {isOpen ? <Close /> : <Menu />}
            </div>
          </div>
        </div>
      </div>
      <div className={isOpen ? style.menu : style.menuClosed}>
        <div
          className={style.menuContent}
          dangerouslySetInnerHTML={{ __html: menuHeader }}
        />
        <div className={style.bar} />
        <div className={style.socialBar}>
          <a
            href={custom_settings["facebook"]}
            target="_blank"
            rel="noopener noreferrer"
            className={style.facebook}
          >
            <Facebook />
          </a>
          <a
            href={custom_settings["youtube"]}
            target="_blank"
            rel="noopener noreferrer"
            className={style.youtube}
          >
            <Youtube />
          </a>
          <a
            href={custom_settings["linkedin"]}
            target="_blank"
            rel="noopener noreferrer"
            className={style.linkedin}
          >
            <LinkedIn />
          </a>
        </div>
      </div>
    </div>
  );
}

export default defineBlock({
  Block,
  setup: {
    title: "Header",
  },
});
